import { View } from "react-native";
import React from "react";
import { Text } from "@ui-kitten/components";
import Button from "components/Button";
import * as Linking from "expo-linking";
import i18n from "plugins/localization";
import { useFetchTenantConfigurationQuery } from "queries/configuration.queries";

const StepTwo = () => {
  const { data: tenantConfig } = useFetchTenantConfigurationQuery();

  if (!tenantConfig) return null;

  const openBrowser = () => Linking.openURL(tenantConfig.buyflowRedirectUrl);

  return (
    <View>
      <Text
        category="h3"
        style={{ textAlign: "center", fontWeight: "700", marginVertical: 20 }}
      >
        No Membership Found
      </Text>
      <Text category="h6" style={{ marginVertical: 25 }}>
        We weren't able to find an existing membership with the account
        information you provided. Click below to view available memberships
      </Text>
      <Button style={{ marginVertical: 15 }} onPress={openBrowser}>
        VIEW AVAILABLE MEMBERSHIPS
      </Button>
    </View>
  );
};

export default StepTwo;
